// extracted by mini-css-extract-plugin
export default {"container":"Cooperation_container__--zPA","title":"Cooperation_title__3b9mp","text":"Cooperation_text__b5tec","item":"Cooperation_item__XfkJL"};